import * as digifie from '../../digifie';
import * as marietta from '..';

export default class PerformanceChecker {
    private CPUScore: HTMLElement;

    private browserScore: HTMLElement;

    private GPUScore: HTMLElement;

    private WebGLScore: HTMLElement;

    private CPUProgress: HTMLElement;

    private browserProgress: HTMLElement;

    private GPUProgress: HTMLElement;

    private WebGLProgress: HTMLElement;

    private TotalScore: HTMLElement;

    private scoreMsg: HTMLElement;

    private performanceNotShowDiv: HTMLElement;

    private helpCheckPerformanceDisplay: HTMLElement;

    private message: string;

    /**
     * コンストラクタ
    */
    constructor() {
      window.addEventListener('pageshow', this.onPageShow);
    }

    private onPageShow = (e: Event): void => {
      if (this.checkWebcadBusy()) {
        const timeoutId = setTimeout(() => {
          clearTimeout(timeoutId);
          this.onPageShow(e);
        }, 100);
        return;
      }
      window.removeEventListener('pageshow', this.onPageShow);
      if (marietta.webcad.WebCADGlobal.userAgentManager.isIE) {
        marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('IE_ERROR_MESSAGE'), marietta.webcad.collection.WebCADMessages.getText('IE_ERROR_TITLE'));
      } else if (localStorage.getItem('notShowPerformance') === '0' || localStorage.getItem('notShowPerformance') === null) {
        const that = this;
        setTimeout(() => {
          marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.performanceDialogLoader, false, false, false, false);
        }, 500);
        setTimeout(() => {
          marietta.webcad.WebCADGlobal.removeDialog();
          marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.performanceDialog, false, false, false, false);
          that.initDOM();
          // 計測開始
          that.performanceCheck();
        }, 2000);
      } else {
        marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
      }
    }

    /**
     * スコア計算DOM要素を初期化する
     * @return void
    */
    private initDOM() {
      this.CPUScore = document.getElementById('cpuScoreValue');
      this.browserScore = document.getElementById('browserScoreValue');
      this.GPUScore = document.getElementById('gpuScoreValue');
      this.WebGLScore = document.getElementById('webglScoreValue');
      this.CPUProgress = document.getElementById('cpuProgress');
      this.browserProgress = document.getElementById('browserProgress');
      this.GPUProgress = document.getElementById('gpuProgress');
      this.WebGLProgress = document.getElementById('webglProgress');
      this.TotalScore = document.getElementById('totalPerformanceScore');
      this.scoreMsg = document.getElementById('scoreMsg');
      this.performanceNotShowDiv = document.getElementById('performanceNotShowDiv');
    }

    private checkWebcadBusy=(): boolean => {
      const element = document.getElementsByClassName('loadingContainer').item(0);
      return (element as HTMLElement).style.display !== 'none';
    }

    /**
     *  パフォーマンス計測
     *  @return void
    */
    private performanceCheck(): void {
      // IE のときの処理
      if (marietta.webcad.WebCADGlobal.userAgentManager.isIE) {
        const performanceResult: { [key: string]: string } = digifie.utils.UA.performanceCheck(5000);
        this.result(performanceResult);
        return;
      }
      // IE 以外ののき
      const ts: number = performance.now(); // performance 計測開始
      for (let i = 0; i < 10000; i += 1) {
        digifie.utils.PerformanceUtil.isPrimeNum(i);
        if (i === 9999) {
          const te: number = performance.now(); // performance 計測終了
          const performanceResult: { [key: string]: string } = digifie.utils.UA.performanceCheck(te - ts);
          this.result(performanceResult);
        }
      }
    }

    /**
     *  パフォーマンススコアDom要素の更新
     *  @return void
    */
    private result(performanceResult: any): void {
      if (performanceResult.totalScore < 50) {
        marietta.webcad.WebCADGlobal.performanceCheckDisplay = false;
        this.performanceNotShowDiv.style.display = 'none';
      } else {
        marietta.webcad.WebCADGlobal.performanceCheckDisplay = true;
        this.performanceNotShowDiv.style.display = 'block';
      }
      this.CPUScore.innerHTML = `${performanceResult.CPUSpeedScore}<span>%</span>`;
      this.browserScore.innerHTML = `${performanceResult.browserScore}<span>%</span>`;
      this.GPUScore.innerHTML = `${performanceResult.GPUScore}<span>%</span>`;
      this.WebGLScore.innerHTML = `${performanceResult.WebGLScore}<span>%</span>`;
      this.CPUProgress.style.width = `${performanceResult.CPUSpeedScore}%`;
      this.browserProgress.style.width = `${performanceResult.browserScore}%`;
      this.GPUProgress.style.width = `${performanceResult.GPUScore}%`;
      this.WebGLProgress.style.width = `${performanceResult.WebGLScore}%`;
      this.scoreMsg.innerHTML = performanceResult.msg;
      this.updateProgressColor(this.CPUProgress, performanceResult.CPUSpeedScore, 1);
      this.updateProgressColor(document.getElementById('CPUArrow'), performanceResult.CPUSpeedScore, 2);
      this.updateProgressColor(this.browserProgress, performanceResult.browserScore, 1);
      this.updateProgressColor(document.getElementById('browserArrow'), performanceResult.browserScore, 2);
      this.updateProgressColor(this.GPUProgress, performanceResult.GPUScore, 1);
      this.updateProgressColor(document.getElementById('GPUArrow'), performanceResult.GPUScore, 2);
      this.updateProgressColor(this.WebGLProgress, performanceResult.WebGLScore, 1);
      this.updateProgressColor(document.getElementById('WebGLArrow'), performanceResult.WebGLScore, 2);
      this.updateProgressColor(this.TotalScore, performanceResult.totalScore, 1);
      const event = new Event('change');
      (<HTMLInputElement>document.getElementById('totalPerformanceScore')).value = performanceResult.totalScore;
      document.getElementById('totalPerformanceScore').dispatchEvent(event);
    }

    /**
     *  スコア値に基づいてパフォーマンスの進行状況の色を設定します
     *  @param element type=HtmlElement;  progress HtmlElement
     *  @param score type=number;  score value
     *  @param styleType type=number;  element style
     *  @return void
    */
    private updateProgressColor=(_element: HTMLElement, score: number, styleType: number = 1) => {
      const element = _element;
      if (element) {
        let progressColor = '#39b54a';
        if (score <= 100 && score >= 80) {
          progressColor = '#39b54a';
        } else if (score < 80 && score >= 60) {
          progressColor = '#d9e021';
        } else if (score < 60 && score >= 30) {
          progressColor = '#f7931e';
        } else if (score < 30 && score >= 0) {
          progressColor = '#f15a24';
        }
        if (element.id === 'totalPerformanceScore') {
          const event = new CustomEvent('configure', { detail: { fgColor: progressColor } });

          document.getElementById('totalPerformanceScore').dispatchEvent(event);
        } else if (styleType === 1) {
          element.style.background = progressColor;
        } else if (styleType === 2) {
          element.style.color = progressColor;
        }
      }
    }
}
// eslint-disable-next-line no-new
new PerformanceChecker();
